export default __webpack_public_path__ + "static/media/megane-gallery-5.16bb6da3.jpg";